// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../../../tailwind.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewer-main-page {
  width: 100%;
  height: calc(100vh - 50px);
  background: #fff;
}
.viewer-main-page iframe {
  background: #000;
}
.viewer-main-page .tips {
  color: #fff;
  background: #000;
  height: 100%;
  font-size: var(--custom-font-size);
}
.viewer-main-page .iframe-box img {
  height: 100%;
  position: absolute;
  margin-left: 50%;
  transform: translateX(-50%);
}
.viewer-main-page .iframe-box pre {
  color: #fff !important;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/StudyListPage/components/ViewerLayoutWrap.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,0BAAA;EACA,gBAAA;AAAF;AAHA;EAMI,gBAAA;AAAJ;AANA;EAUI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;AADJ;AAZA;EAiBI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAFJ;AAlBA;EAwBI,sBAAA;EACA,eAAA;AAHJ","sourcesContent":["@import url('../../../tailwind.css');\n\n.viewer-main-page {\n  width: 100%;\n  height: calc(100vh - 50px);\n  background: #fff;\n\n  iframe{\n    background:#000;\n  }\n\n  .tips {\n    color: #fff;\n    background:#000;\n    height:100%;\n    font-size: var(--custom-font-size)\n  }\n\n  .iframe-box img {\n    height: 100%;\n    position: absolute;\n    margin-left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .iframe-box pre {\n    color: #fff !important;\n    font-size: 20px;\n  }\n\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
